var __jsx = React.createElement;
import React from "react";
import { motion } from "framer-motion";
import RequirementsSection from "./RequirementsSection";
import AdditionalRequirementsSection from "./AdditionalRequirementsSection";
var RequirementsContent = function RequirementsContent(_ref) {
  var activeTab = _ref.activeTab,
    newCarsData = _ref.newCarsData;
  var getRequirementsData = function getRequirementsData() {
    if (activeTab === "saudi" && 'financeRequirementsDataSaudi' in newCarsData) {
      return newCarsData.financeRequirementsDataSaudi;
    }
    return (newCarsData === null || newCarsData === void 0 ? void 0 : newCarsData.financeRequirementsDataResident) || [];
  };
  var getAdditionalData = function getAdditionalData() {
    if (activeTab === "saudi" && 'additionalDataSaudi' in newCarsData) {
      return newCarsData.additionalDataSaudi;
    }
    return (newCarsData === null || newCarsData === void 0 ? void 0 : newCarsData.additionalDataResident) || [];
  };
  return /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      opacity: 0,
      x: -20
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: 20
    },
    transition: {
      duration: 0.3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 px-3 md:flex-row md:px-5"
  }, /*#__PURE__*/React.createElement(RequirementsSection, {
    title: newCarsData.firstTitle,
    requirements: getRequirementsData()
  }), /*#__PURE__*/React.createElement(AdditionalRequirementsSection, {
    title: newCarsData.secondTitle,
    items: getAdditionalData()
  })));
};
export default RequirementsContent;